import {createMuiTheme} from "@material-ui/core/styles";

export function getMuiTheme(onPlatform) {
  const theme = {
    typography: {
      fontFamily: `"Formular", "Arial", sans-serif`,
      useNextVariants: true
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 740,
        md: 940,
        lg: 1240,
        xl: 1440
      }
    }
  };

  if (onPlatform === `vtb`) {
    theme.typography.fontFamily = `"VTB Group", Arial, sans-serif`;
  }

  return createMuiTheme(theme);
}
